import styled from "vue-styled-components";

export default styled.div`
  & .autocomplete-content {
    position: relative;
    & .icon-search {
      position: absolute;
      z-index: 9;
      top: 50%;
      left: 5px;
      transform: translateY(-50%);
      display: flex;
      justify-content: center;
      align-items: center;
      color: #cccccc;
    }
    & input {
      padding-left: 30px;
    }
    & .options-container {
      position: absolute;
      overflow: auto;
      overflow-x: hidden;
      max-height: 300px;
      display: none;
      &.open {
        display: block;
      }
      top: 100%;
      left: 0;
      right: 0;
      background-color: #ffffff;
      z-index: 9;
      box-shadow: 0px 1px 1px #cecece;
      border: 1px solid #dbdbdb;
      border-top: 0;
      padding-top: 5px;
      padding-bottom: 5px;
      & .options-ul {
        padding: 0;
        margin: 0;
        & .option-item {
          margin: 0;
          padding: 0;
          & .option-link {
            display: flex;
            padding: 5px 6px;
            cursor: pointer;
            font-size: 0.96em;
            display: flex;
            & .icon {
              color: #cccccc;
            }
            & .label {
              font-weight: normal;
              &.user-container {
                display: flex;
                flex-direction: column;
              }
              & .username {
                font-weight: bold;
              }
              & .number-resume, & .identification  {
                color: #818181;
              }
              & .identification {
                font-size: 0.9em;
              }
            }
            &:hover {
              background-color: #f5f5f5;
              & .icon {
                color: inherit;
              }
            }
          }
        }
      }
    }
  }
`;
